module.exports = __webpack_public_path__ + "static/media/navlogo.f6f6d186.svg";